export default {
    name: 'filters',
    store() {
        return {
            open: false,
            init() {
                // console.log('Arctheme Filters Component Initialized.')
            },
            toggle() {
                this.open = !this.open
            },
            close() {
                this.open = false
            },
            openDropdown() {
                this.open = true
            },
        }
    }
}
